import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DataService } from './core/data.service';
@Injectable({
    providedIn: 'root'
})

export class UploadUCMService extends DataService {
    context = 'uploadfiles';

    public progress: number;
    public message: string;

    uploadFilesFiscal(formDataUpload: FormData) {
        return this.post<any>(null, formDataUpload);
    }

    upload(formDataUpload: FormData): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/UploadFiles`;

        const headers = new HttpHeaders({
            'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT'
        });

        const options = {
                headers: headers
        };

        return this.http.post<any>(apiURL, formDataUpload, options);
    }
}

